import QuillBetterTable from "quill-better-table";

export default {
  customModulesForEditor: [{ alias: "tables", module: QuillBetterTable }],
  editorSettings: {
    modules: {
      toolbar: {
        container: [
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          ["bold", "italic", "underline", "strike"],
          [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
          [{ list: "ordered" }, { list: "bullet" }],
          [{ color: [] }, { background: [] }],
          ["link"],
          ["clean"],
        ],
      },
    },
    table: false,
    "better-table": {
      items: {
        unmergeCells: {
          text: "",
        },
      },
    },
  },
  editorSettingsNoHeader: {
    modules: {
      toolbar: false,
    },
  },
};
